import { createBrowserRouter } from 'react-router-dom';
import { lazy } from 'react';

// project imports
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';
import Loadable from 'components/Loadable';

const NotFoundPage = Loadable(lazy(() => import('pages/NotFound')));

const basename = import.meta.env.VITE_APP_BASE_NAME?.trim() || undefined;

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter([MainRoutes, LoginRoutes, { path: '*', element: <NotFoundPage /> }], { basename });

export default router;
